module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.subjectsIsLoaded) ? _c('div', {
    attrs: {
      "id": "pg-app"
    }
  }, [_c('table', {
    staticClass: "pgAvgTbl pgAvgTblPc mdTable01 mt10"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "pgAvgTblCol1"
  }, [_vm._v("教科")]), _vm._v(" "), _c('th', {
    staticClass: "pgAvgTblCol2"
  }, [_vm._v("科目")]), _vm._v(" "), _c('th', {
    staticClass: "pgAvgTblCol4",
    domProps: {
      "innerHTML": _vm._s(_vm.props.ttlThisYear)
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "pgAvgTblCol6",
    domProps: {
      "innerHTML": _vm._s(_vm.props.ttlLastYear)
    }
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.categories), function(category, categoryIndex) {
    return (_vm.categories) ? _vm._l((category.subjects), function(subject, subjectIndex) {
      return _c('tr', [(subjectIndex === 0) ? [_c('th', {
        staticClass: "pgAvgTblCol1",
        attrs: {
          "rowspan": category.subjects.length
        }
      }, [_vm._v(_vm._s(category.name))])] : _vm._e(), _vm._v(" "), _c('th', {
        staticClass: "pgAvgTblCol2 pgAvgTblSubSubjectName mdTableLead"
      }, [_vm._v(_vm._s(subject.name))]), _vm._v(" "), _c('td', {
        staticClass: "mdCol01"
      }, [_vm._v(_vm._s(subject.thisYear))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject.lastYear))])], 2)
    }) : _vm._e()
  })], 2)]), _vm._v(" "), _c('table', {
    staticClass: "pgAvgTbl pgAvgTblSp mdTable01 mt10"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "pgAvgTblCol2",
    domProps: {
      "innerHTML": _vm._s(_vm.props.ttlThisYear)
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "pgAvgTblCol4",
    domProps: {
      "innerHTML": _vm._s(_vm.props.ttlLastYear)
    }
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.categories), function(category, categoryIndex) {
    return [_c('tr', [_c('th', {
      staticClass: "pgAvgTblSubjectName",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v(_vm._s(category.name))])]), _vm._v(" "), _vm._l((category.subjects), function(subject, subjectIndex) {
      return [_c('tr', [_c('th', {
        staticClass: "pgAvgTblSubSubjectName mdTableLead",
        attrs: {
          "colspan": "4"
        }
      }, [_vm._v(_vm._s(subject.name))])]), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "mdCol01"
      }, [_vm._v(_vm._s(subject.thisYear))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject.lastYear))])])]
    })]
  })], 2)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44c9bc00","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/sokuhou/yosou/App.vue
// module id = 955
// module chunks = 14